import React, { useState } from "react";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { ServiceUrl } from "../../../utils/serviceUrl";
import { DB_POSTFIX } from "../../../utils";

const SearchPage = ({ onClose }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);

  const handleSearchChange = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.length < 2) {
      setSearchResults([]);
      return;
    }

    setSearching(true);
    try {
      const res = await axios.get(ServiceUrl.SEARCH + "?sadb=" + DB_POSTFIX, {
        params: {
          type: "page",
          search: value,
        },
      });

      if (res.data.status === "1") {
        setSearchResults(res.data.data);
      } else {
        setSearchResults([]);
      }
    } catch (error) {
      console.error("Search error:", error);
      setSearchResults([]);
    } finally {
      setSearching(false);
    }
  };

  return (
    <div className="search-overlay" onClick={onClose}>
      {/* Search Box Container */}
      <div
        className="search-box"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        {/* Close Button */}
        <button
          className="close-btn"
          onClick={onClose}
          aria-label="Close search"
        >
          &times;
        </button>

        {/* Search Input */}
        <input
          type="text"
          className="form-control search-input"
          placeholder="Type to search..."
          value={searchTerm}
          onChange={handleSearchChange}
          autoFocus
        />

        {/* Loader */}
        {searching && (
          <div className="text-center mt-3">
            <Spinner animation="border" size="sm" />
          </div>
        )}

        {/* Search Results */}
        <ul className="list-group mt-3">
          {searchResults.length > 0
            ? searchResults.map((item) => (
                <li
                  key={item.id}
                  className="list-group-item list-group-item-action gs-title"
                  onClick={() => {
                    window.location.href = "/" + item.seo_slug;
                    onClose();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {item.title}
                </li>
              ))
            : !searching &&
              searchTerm.length > 1 && (
                <li className="list-group-item text-center text-muted">
                  No results found
                </li>
              )}
        </ul>
      </div>
    </div>
  );
};

export default SearchPage;
